import React, { Component } from "react";
import classnames from "classnames";
import { SSelect } from '@avalara/skylab-sdk/react';

const defaultButton = props => (
  <button type="button" {...props} className="-btn">
    {props.children}
  </button>
);

export default class ReactTablePagination extends Component {
  static defaultProps = {
    PreviousComponent: defaultButton,
    NextComponent: defaultButton,
    renderPageJump: ({
      onChange,
      value,
      onBlur,
      onKeyPress,
      inputType,
      pages,
      renderTotalPagesCount,
      pageJumpText
    }) => (
      <div className="-pageJump">
        <input
          aria-label={pageJumpText}
          type={inputType}
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          onKeyPress={onKeyPress}
        />
      </div>
    ),
    renderCurrentPage: page => <span className="-currentPage">{page + 1}</span>,
    renderTotalPagesCount: pages => (
      <span className="-totalPages pad-left-xs">{pages || 1}</span>
    ),
    renderPageSizeOptions: ({
      pageSize,
      pageSizeOptions,
      rowsSelectorText,
      onPageSizeChange,
      rowsText
    }) => (
      <span className="select-wrap -pageSizeOptions float-right">
        <SSelect
          inputId="pagination-page-size"
          aria-label={rowsSelectorText}
          optionsList={pageSizeOptions.map((option, i) => ({
            key: i.toString(),
            value: option.toString(),
            label: `${option} ${rowsText}`,
            selected: pageSize === option
          }))}
          multiple={false}
          onS-select={(e) => onPageSizeChange(Number(e.detail.item.value))}
        />
      </span>
    )
  };

  constructor(props) {
    super(props);

    this.getSafePage = this.getSafePage.bind(this);
    this.changePage = this.changePage.bind(this);
    this.applyPage = this.applyPage.bind(this);

    this.state = {
      page: props.page
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.page !== nextProps.page) {
      this.setState({ page: nextProps.page });
    }
  }

  getSafePage(page) {
    if (Number.isNaN(page)) {
      page = this.props.page;
    }
    return Math.min(Math.max(page, 0), this.props.pages - 1);
  }

  changePage(page) {
    page = this.getSafePage(page);
    this.setState({ page });
    if (this.props.page !== page) {
      this.props.onPageChange(page);
    }
  }

  applyPage(e) {
    if (e) {
      e.preventDefault();
    }
    const page = this.state.page;
    this.changePage(page === "" ? this.props.page : page);
  }

  getPageJumpProperties() {
    return {
      onKeyPress: e => {
        if (e.which === 13 || e.keyCode === 13) {
          this.applyPage();
        }
      },
      onBlur: this.applyPage,
      value: this.state.page === "" ? "" : this.state.page + 1,
      onChange: e => {
        const val = e.target.value;
        const page = val - 1;
        if (val === "") {
          return this.setState({ page: val });
        }
        this.setState({ page: this.getSafePage(page) });
      },
      inputType: this.state.page === "" ? "text" : "number",
      pageJumpText: this.props.pageJumpText
    };
  }

  render() {
    const {
      // Computed
      pages,
      // Props
      page,
      showPageSizeOptions,
      pageSizeOptions,
      pageSize,
      showPageJump,
      canPrevious,
      canNext,
      onPageSizeChange,
      className,
      PreviousComponent,
      NextComponent,
      renderPageJump,
      renderCurrentPage,
      renderTotalPagesCount,
      renderPageSizeOptions
    } = this.props;

    return (
      <div
        className={classnames(className, "-pagination")}
        style={{ ...(this.props.style || {}), overflow: 'visible' }}
      >
        <s-container class="full-width">
          <s-row>
            <s-col span="3" class="pb0">
              {/* Future 1-10 of 999 functionality will go here */}
            </s-col>
            <s-col span="6" class="center pb0">
              <div className="-previous mr20">
                <PreviousComponent
                  onClick={() => {
                    if (!canPrevious) return;
                    this.changePage(page - 1);
                  }}
                  disabled={!canPrevious}
                >
                  <s-icon name="chevron-left"></s-icon> Prev
                  {/* Replace with language string */}
                </PreviousComponent>
              </div>
              <span className="-pageInfo relative">
                {this.props.pageText}{" "}
                {showPageJump
                  ? renderPageJump(this.getPageJumpProperties())
                  : renderCurrentPage(page)}{" "}
                <span className="totals">{this.props.ofText} {renderTotalPagesCount(pages)}</span>
              </span>
              <div className="-next ml20">
                <NextComponent
                  onClick={() => {
                    if (!canNext) return;
                    this.changePage(page + 1);
                  }}
                  disabled={!canNext}
                >
                  Next <s-icon name="chevron-right"></s-icon>
                  {/* Replace with language string */}
                </NextComponent>
              </div>
            </s-col>
            <s-col span="3" class="pr0 pb0">
              {showPageSizeOptions &&
                renderPageSizeOptions({
                  pageSize,
                  rowsSelectorText: this.props.rowsSelectorText,
                  pageSizeOptions,
                  onPageSizeChange,
                  rowsText: "per page"
              })}
            </s-col>
          </s-row>
        </s-container>
      </div>
    );
  }
}
